import { useStytchMember } from "@stytch/react/b2b";
import { doesUserHavePackages, PossiblePackage } from "@/lib/models/auth";

/** Whether the signed-in member has the developer package. */
export function useIsDeveloper(): boolean {
  const { member } = useStytchMember();
  return doesUserHavePackages({ requiredPackages: [PossiblePackage.Developer], member });
}
